<template>
  <div class="content" v-if="$store.state.user.scope" v-bind:class="{fullHeight: isSaving}">
    <mu-card class="bottom" v-if="!isSaving">
      <mu-card-header :title="$t('message.labelTime')" class="greyed aio-input-header" titleClass="alignMiddle lightTitle">
        <mu-icon class="alignMiddle dateIcon" slot="avatar" value="access_time"></mu-icon>
      </mu-card-header>
      <mu-card-text>
        <p>{{$t('message.labelProgressDatePickerExplain')}}</p>
      </mu-card-text>
      <mu-row gutter>
        <mu-col width="100" desktop="50" tablet="50" class="mobile">
          <date-picker
            iconMode
            v-model="date"
            type="datetime"
          ></date-picker>
        </mu-col>
        <mu-col width="100" desktop="50" tablet="50"></mu-col>
      </mu-row>
    </mu-card>
    <mu-row gutter v-if="!isSaving">
      <mu-col desktop="50" tablet="50" width="100">

        <aio-pictures
          class="bottom">
        </aio-pictures>

        <aio-weight
          class="bottom"
          @onValid="onWeightValid"
        ></aio-weight>
        <aio-blood-glucose
          class="bottom"
          @onValid="onBloodGlucoseValid"
        ></aio-blood-glucose>
        <aio-hba1c
          class="bottom"
          @onValid="onHba1cValid"
        ></aio-hba1c>
        <aio-insulin
          class="bottom"
          @onValid="onInsulinValid"
        ></aio-insulin>
        <aio-sleep
          class="bottom"
          @onValid="onSleepValid"
        ></aio-sleep>
      </mu-col>
      <mu-col desktop="50" tablet="50" width="100">
        <aio-ketones
          class="bottom"
          @onValid="onKetonesValid"
        ></aio-ketones>

        <aio-blood-pressure
          class="bottom"
          @onValid="onBloodPressureValid"
        ></aio-blood-pressure>

        <aio-mood
          class="bottom"
          @onValid="onMoodValid"
        ></aio-mood>

        <aio-medication
          class="bottom"
          @onValid="onMedicationValid"
        ></aio-medication>

        <aio-cholesterol
          @onValid="onCholesterolValid"
        ></aio-cholesterol>

      </mu-col>
    </mu-row>
    <mu-flexbox v-if="isSaving" justify="center" align="center" style="height: 100%;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="48" mode="indeterminate" color="#0179d5 !important"></mu-circular-progress>
        <br/><br/>
        {{$t('message.savingText')}}
      </mu-flexbox-item>
    </mu-flexbox>
    <mu-float-button
      v-tooltip.left="'Save all'"
      @click.native="processQueue()"
      v-bind:style="{'right': getScrollbarWidth() + 24 + 'px'}"
      v-if="objectsHydrated > 0 && !isSaving && isFabShown === true"
      class="confirmFloat animated fadeIn"
      icon="check"
      secondary
    ></mu-float-button>
    <tracking-notifier
      v-if="$store.state.user.scope"
      :userId="$store.state.user.scope.user_id"
    ></tracking-notifier>
    <div ref="scrollDetector"></div>
  </div>
</template>
<script>



  import DatePicker from "../../components/DateTimePicker/DateTimePicker.vue";



  import ScrollManager from '../../helpers/ScrollManager'
  import ScrollerMixin from '../../mixins/ScrollerMixin'

  import AioSleep from "./aio-components/Sleep/Sleep";
  import AioHba1c from "./aio-components/HbA1c/HbA1c.vue";
  import AioBloodGlucose from "./aio-components/BloodGlucose/BloodGlucose.vue";
  import AioBloodPressure from "./aio-components/BloodPressure/BloodPressure.vue";
  import AioMood from "./aio-components/Mood/Mood.vue";
  import AioKetones from "./aio-components/Ketones/Ketones.vue";
  import AioMedication from "./aio-components/Medication/Medication";
  import AioInsulin from "./aio-components/Insulin/Insulin";
  import AioWeight from "./aio-components/Weight/Weight.vue";
  import AioCholesterol from "./aio-components/Cholesterol/Cholesterol";
  import TrackingNotifier from "../../components/TrackingNotifier/TrackingNotifier.vue"


  import TrackingApi from '../../api/Tracking';
  import AioPictures from "./aio-components/Picture/Pictures";
  export default {
    mixins: [ScrollerMixin],
    components: {
      AioPictures,
      TrackingNotifier,
      AioCholesterol,
      AioMedication,
      AioKetones,
      AioMood,
      AioBloodPressure,
      AioBloodGlucose,
      AioHba1c,
      AioSleep,
      AioInsulin,
      AioWeight,
      DatePicker
    },
    watch: {
      model: {
        handler() {
          let self = this;
          let objectsHydrated = _.filter(self.model, function (object) {
            return object !== null;
          });
          self.objectsHydrated = _(objectsHydrated).size();
        },
        deep: true
      }
    },
    data() {
      return {
        objectsHydrated: 0,
        date: "",
        isFabShown: true,
        isSaving: false,
        model: {
          weight: null,
          hba1c: null,
          bloodGlucose: null,
          sleep: null,
          cholesterol: null,
          ketones: null,
          mood: null,
          medication: null,
          bloodPressure: null,
          insulin: null
        }
      }
    },
    mounted() {
      let self = this;
      self.scroller.addEventListener('scroll', self.checkIfFabShouldBeShown)
    },
    methods: {
      checkIfFabShouldBeShown() {
        let self = this;
        if (self.scroller.clientWidth <= 600) {
          ScrollManager.isElementInViewport(self.$refs.scrollDetector) ? self.isFabShown = false : self.isFabShown = true;
        }
      },
      getScrollbarWidth() {
        return ScrollManager.getScrollbarWidth();
      },
      processQueue() {
        let self = this;
        let model = JSON.parse(JSON.stringify(self.model));
        for (let prop in model) {
          if (model.hasOwnProperty(prop)) {
            if (model[prop] === null || model[prop] === undefined) {
              delete model[prop];
            }
          }
        }
        for (let prop in model) {
          if (model.hasOwnProperty(prop)) {
            model[prop].date = self.date;
          }
        }
        self.isSaving = true;
        TrackingApi.addProgress(model)
          .then(function (response) {
            let complete = response.data;
            if (complete.weight === true) {
              self.$store.commit('setWeightCard', {});
            }
            if (complete.bloodGlucose === true) {
              self.$store.commit('setBloodGlucoseCard', {});
            }
            if (complete.bloodPressure === true) {
              self.$store.commit('setBloodPressureCard', {});
            }
            if (complete.medication === true) {
              self.$store.commit('setMedicationCard', {});
            }
            if (complete.ketones === true) {
              self.$store.commit('setKetonesCard', {})
            }
            if (complete.sleep === true) {
              self.$store.commit('setSleepCard', {});
            }
            if (complete.mood === true) {
              self.$store.commit('setMoodCard', {});
            }
            if (complete.insulin === true) {
              self.$store.commit('setInsulinCard', {});
            }
            self.$router.push({
              name: 'Dashboard'
            });
            self.$toastr.success("Progress data added");
          });
      },
      onCholesterolValid(model) {
        this.model.cholesterol = model;
      },
      onMedicationValid(model) {
        this.model.medication = model;
      },
      onWeightValid(model) {
        this.model.weight = model;
      },
      onBloodPressureValid(model) {
        this.model.bloodPressure = model;
      },
      onBloodGlucoseValid(model) {
        this.model.bloodGlucose = model;
      },
      onHba1cValid(model) {
        this.model.hba1c = model;
      },
      onInsulinValid(model) {
        this.model.insulin = model;
      },
      onSleepValid(model) {
        this.model.sleep = model;
      },
      onMoodValid(model) {
        //clears previous moods.
        this.model.mood = null;
        this.model.mood = model;
      },
      onKetonesValid(model) {
        this.model.ketones = model;
      }
    },
    beforeDestroy() {
      let self = this;
      if (self.scroller !== null) {
        self.scroller.removeEventListener('scroll', self.checkIfFabShouldBeShown)
      }
    }
  }
</script>
<style>
  @import "./aio.css";

  .fullHeight {
    height: 100%;
    min-height: 100%;
    max-height: 100%;
  }

  .mu-card-header.greyed.aio-input-header .mu-card-title {
    color: initial !important;
    font-size: 14px;
    margin-top: 2px;
  }

</style>



// WEBPACK FOOTER //
// AddProgress.vue?74f359ea